module.exports = __webpack_public_path__ + "static/3-246f3c1e44beff707a27f2b411d5693d.jpg";